import { motion } from 'framer-motion';
import { theme } from '../../theme';

interface ProgressBarProps {
  value: number;
  max?: number;
  label?: string;
  showPercentage?: boolean;
  color?: 'danger' | 'warning' | 'success';
  height?: 'sm' | 'md' | 'lg';
}

const heightMap = { sm: '6px', md: '12px', lg: '20px' };

export const ProgressBar = ({
  value, max = 100, label, showPercentage = true,
  color = 'danger', height = 'md',
}: ProgressBarProps) => {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  const fill = theme.variantColors[color] || theme.brand.crimson;

  return (
    <div>
      {(label || showPercentage) && (
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: theme.spacing[1],
        }}>
          {label && (
            <span style={{
              fontFamily: theme.typography.fontFamily.display,
              fontSize: theme.typography.fontSize.xs,
              fontWeight: theme.typography.fontWeight.bold,
              color: theme.semantic.text.muted,
              letterSpacing: theme.typography.letterSpacing.widest,
              textTransform: 'uppercase' as const,
            }}>
              {label}
            </span>
          )}
          {showPercentage && (
            <span style={{
              fontFamily: theme.typography.fontFamily.mono,
              fontSize: theme.typography.fontSize.xs,
              fontWeight: theme.typography.fontWeight.bold,
              color: theme.semantic.text.primary,
            }}>
              {pct.toFixed(0)}%
            </span>
          )}
        </div>
      )}

      {/* Track */}
      <div style={{
        width: '100%',
        height: heightMap[height],
        background: theme.semantic.bg.elevated,
      }}>
        {/* Fill */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          style={{
            height: '100%',
            background: fill,
          }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
